import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Grid, Popup } from 'semantic-ui-react';
import { Formik } from 'formik';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import styles from './AddComment.module.css';
import AddAttachment from './AddAttachment';
import { getFileName } from '../../../../HelperMethods/UtilityFunctions';
import AttachmentView from '../../../common/AttachmentView';

function onFilesSelected(formik, files) {
  const attachments = [..._.get(formik, 'values.attachments', [])];
  const newAttachments = Array.from(files).map((file) => {
    return {
      file,
    };
  });
  attachments.push(...newAttachments);
  formik.setFieldValue('attachments', attachments, false);
}

function onAttachmentRemovedInFormik(index, formik) {
  const attachments = [..._.get(formik, 'values.attachments', [])];
  attachments.splice(index, 1);
  formik.setFieldValue('attachments', attachments, false);
}

function AddComment({
  onAddButtonClicked,
  validateForm,
  addCommentLoading,
  commentFormInitialValue,
  onCancelButtonClicked,
}) {
  const textBoxRef = useRef();
  const [openValidationPopup, setOpenValidationPopup] = React.useState(false);
  const loggedInUser = useSelector((state) => state.appReducer.loggedInUser);
  return (
    <Grid.Column style={{ padding: '0' }}>
      {addCommentLoading && (
        <div className="hover-loading">
          <div className="joyn2-loader" />
        </div>
      )}
      <Formik
        initialValues={commentFormInitialValue}
        enableReinitialize
        validate={validateForm}
        onSubmit={onAddButtonClicked}
      >
        {(formik) => {
          return (
            <form
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <Grid
                padded
                className={styles.commentContainer}
                style={{ borderColor: formik.errors.comment && formik.touched.comment ? 'red' : '#4c4c4c' }}
              >
                <Grid.Row columns={1} style={{ padding: '0px' }}>
                  <Grid.Column>
                    <input
                      name="comment"
                      value={formik.values.comment}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Type here"
                      className={styles.commentInput}
                      autoComplete="off"
                      ref={textBoxRef}
                      onMouseEnter={() => {
                        setOpenValidationPopup(true);
                      }}
                      onMouseLeave={() => {
                        setOpenValidationPopup(false);
                      }}
                    />
                    <Popup
                      context={textBoxRef}
                      content={_.get(formik, 'errors.comment', '')}
                      open={!!_.get(formik, 'errors.comment') && openValidationPopup}
                    />
                  </Grid.Column>
                </Grid.Row>
                <CommentAttachments
                  attachments={_.get(formik, 'values.attachments')}
                  onAttachmentRemoved={(index) => onAttachmentRemovedInFormik(index, formik)}
                />
                <Grid.Row style={{ padding: '0px' }} className={styles.commentActionButtonContainer}>
                  <Grid.Column width={7} floated="left">
                    <AddAttachment
                      onFilesSelected={(files) => {
                        onFilesSelected(formik, files, loggedInUser);
                      }}
                    />
                  </Grid.Column>
                  <Grid.Column width={9} floated="right" style={{ textAlign: 'right' }}>
                    {_.get(formik, 'values.id') && (
                      <button className={styles.buttons} type="button" onClick={onCancelButtonClicked}>
                        Cancel <i className="fa fa-times" />
                      </button>
                    )}
                    {/* eslint-disable-next-line react/button-has-type */}
                    <button className={styles.buttons} onClick={formik.handleSubmit}>
                      {_.get(formik, 'values.id') ? 'Update' : 'Send'} <i className="fa fa-send" />
                    </button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </form>
          );
        }}
      </Formik>
    </Grid.Column>
  );
}

AddComment.propTypes = {
  onAddButtonClicked: PropTypes.func.isRequired,
  addCommentLoading: PropTypes.bool.isRequired,
  validateForm: PropTypes.func.isRequired,
  commentFormInitialValue: PropTypes.object,
  onCancelButtonClicked: PropTypes.func.isRequired,
};

export default AddComment;

const CommentAttachments = React.memo(function CommentAttachments({ attachments, onAttachmentRemoved }) {
  if (!attachments || !attachments.length) return null;
  return (
    <Grid.Row className={styles.commentAttachmentRow}>
      {attachments.map((attachment, index) => (
        <AttachmentView
          key={index}
          attachment={attachment}
          onRemoveButtonClick={() => {
            onAttachmentRemoved(index);
          }}
          name={attachment.fileName || (attachment.key && getFileName(attachment.key)) || attachment.file.name}
        />
      ))}
    </Grid.Row>
  );
});
